import styled from "styled-components";

export const EmptyStateWrapper = styled.div`
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
`; 

export const ContentTopWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 32px;
`;

export const ModelSelectWrapper = styled.div`  
  max-width: 100%;
  flex: 1;
`;

export const ContentBottomWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 28px;
  align-items: start;
`;
export const ContentBottomLeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
export const ContentBottomLeftImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
export const ContentBottomLeftInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ContentBottomRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ContentRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ContentBottomRightColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentBottomLeftVINWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;